import { HubConnectionState } from '@microsoft/signalr';
import { createAction, props } from '@ngrx/store';
import { IDomainMessage } from '@ra-state';

export const disconnect = createAction('[SignalR] Stop Connection');

export const updateConnectionState = createAction(
  '[SignalR] Update Connection State',
  props<{ payload: HubConnectionState; error?: any }>(),
);

export const setDomainMessageReceived = createAction(
  '[SignalR] Domain message received',
  props<{ payload: IDomainMessage }>(),
);
